import { render, staticRenderFns } from "./add-notation-modal.vue?vue&type=template&id=0315192f&scoped=true&"
import script from "./add-notation-modal.vue?vue&type=script&lang=ts&"
export * from "./add-notation-modal.vue?vue&type=script&lang=ts&"
import style0 from "./add-notation-modal.vue?vue&type=style&index=0&id=0315192f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315192f",
  null
  
)

export default component.exports